import React from "react";
import "./style.css";
import { Container, Row, Col } from "react-bootstrap";
import { dataportfolio } from "../../content_option";

export const Portfolio = () => {
  return (
    <Container className="About-header">
      <Row className="mb-5 mt-3">
        <Col lg="12">
          <h1 className="display-4 mb-4"> Portfolio </h1>{" "}
          <hr className="t_border my-4 ml-0 text-left" />
        </Col>
      </Row>
      <div className="mb-5 po_items_ho">
        {dataportfolio.map((data, i) => {
          return (
            <div key={i} className="po_item">
              <img src={data.img} alt="" />
              <div className="content">
                <p>{data.desctiption}</p>
                <a target="_blank" rel="noreferrer" href={data.link}>Bild öffnen</a>
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};
